module.exports = __webpack_public_path__ + "img/fisb.db5fd878.png";